import React, { useState } from 'react'
import SearchBar from '../../components/AdminDashboard/SearchBar';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import Loader from '../common/Loader';
import { TableDataSkeleton } from '../../components/SkeletonLoader';

export default function SearchUser() {
  const [searchedUsers, setSearchedUser] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = searchedUsers?.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <div style={{ margin: "100px auto", maxWidth: "1200px", padding: "0 20px" }}>
      <h1 id="head_dash" style={{ margin: "30px 0", textAlign: "left" }}>
        Search User
      </h1>

      <SearchBar setLoading={setLoading} setSearchedUser={setSearchedUser} />

      {searchedUsers !== undefined && !loading &&
        <div
          className="shadow-box admin-box"
          style={{ width: "95%", marginTop: "10px" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          ></div>
          <hr style={{ marginBottom: "20px" }} />
          <div className="table">
            <table style={{ textAlign: "left" }}>
              <thead>
                <tr>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Name</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Email</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Profile</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Country</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>CreatedOn</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers?.map((user, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: "left" }}>
                      {user.profileType === "ngo" ||
                        user.profileType === "impactOrg" ||
                        user.profileType === "business"
                        ? user.businessName
                        : user?.firstName + " " + user?.lastName}
                    </td>
                    <td style={{ textAlign: "left" }}>
                      {user.email}
                    </td>
                    <td style={{ textAlign: "left" }}>
                      {user.profileType}
                    </td>
                    <td style={{ textAlign: "left" }}>
                      {user.country}
                    </td>
                    <td style={{ textAlign: "left" }}>
                      {moment(user.createdDate).format("DD-MM-YYYY hh:mm A")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={Math.ceil(searchedUsers?.length / itemsPerPage)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          </div>
        </div>
      }

      {loading &&  
        <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
          <TableDataSkeleton/>
        </div>
      }

    </div>
  )
}